<template>
  <div>
    <PageHeader :displayable_links="['campaign_insights', 'campaign_edit']"></PageHeader>
    <tracking-sections></tracking-sections>
  </div>
</template>


<script>
import PageHeader from '@/views/campaigns/components/PageHeader.vue'
import TrackingSections from '@/views/campaigns/tracking/components/TrackingSections.vue'

export default {
  components: {
    PageHeader,
    TrackingSections
  }
}
</script>